import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/date_utils";
import CustomModal from "../../components/UiComponent/Modal";
import RegisterTaskReportForm from "./RgisterTaskReport";
import ApproveTaskReportForm from "./approveTaskReport";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../components/UiComponent/customTable";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
import {
  get_my_task_status,
  get_Branch_task_requests,
} from "../../services/employeeApi";
import Card from "../../components/Card";
const TaskApproveRequests = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = GetUserInfo();
  const emp_id = user.employee.id;
  const isManager = user?.accessRole === "manager";
  const [showModal, setShowModal] = useState(false);
  const [ApproveRequestData, setApproveRequestData] = useState();
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleUpdateShowModal = () => setShowUpdateModal(true);
  const handleUpdateCloseModal = () => setShowUpdateModal(false);
  const handleupdateButtonSubmit = () => {
    handleUpdateCloseModal();
  };
  const [reportData, setReportData] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const queryKey = [
    "get-task-approval-requests",
    isManager ? user?.emp_id : user?.employee?.branch_id,
  ];
  const queryFn = isManager
    ? () => get_Branch_task_requests(user?.employee?.branch_id)
    : () => get_my_task_status(user?.emp_id);

  const { data: myTaskStatus = [], isLoading, isError, error } = useQuery(
    queryKey,
    queryFn,
    {
      enabled: !!user,
    }
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const updateReport = (event, data) => {
    event.preventDefault();
    setApproveRequestData(data);
    handleUpdateShowModal();
  };
  const myTaskColimns = [
    {
      header: "name",
      accessorFn: (row) =>
        `${row.employee_first_name} ${row.employee_father_name} `,
    },

    {
      header: "task_name",
      accessorFn: (row) => `${row.task_title}`,
    },
    {
      header: "date",
      accessorKey: "date",
    },
    {
      header: "quantity",
      accessorKey: "quantity",
    },
    ...(isManager
      ? [
          {
            header: "rate",
            accessorFn: (row) => `${row.manager_rating}%`,
          },
        ]
      : []),

    ...(isManager
      ? [
          {
            header: "score",
            accessorFn: (row) => `${row.final_score}%`,
          },
        ]
      : []),
    {
      header: "status",
      cell: ({ row }) => {
        const task = row.original;
        const status = task.status;
        let badgeClass = "bg-secondary";
        let actionContent = null;

        if (status === "pending") {
          badgeClass = "bg-warning text-dark";
        } else if (status === "approved") {
          badgeClass = "bg-success";
          actionContent = <span className="text-success"></span>;
        } else if (status === "rejected") {
          badgeClass = "bg-danger";
        } else if (status === "canceled") {
          badgeClass = "bg-secondary";
        }

        if (
          !actionContent &&
          hasAccess(["administrator", "manager"], user.accessRole)
        ) {
          actionContent = (
            <Button
              variant="info"
              size="sm"
              onClick={(e) => updateReport(e, task)}
            >
              {t("approve")}
            </Button>
          );
        } else if (!actionContent) {
          actionContent = "Request sent";
        }

        return (
          <div>
            <span className={`badge ${badgeClass}`}>{status}</span>
            {actionContent}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <BasicTable
        data={myTaskStatus.data}
        columns={myTaskColimns}
        title={`Recent Submissions`}
      />
      <CustomModal
        show={showModal}
        title="task_report_form"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <RegisterTaskReportForm
            onSubmitButton={handleButtonSubmit}
            reportData={reportData}
          />
        }
      />
      <CustomModal
        show={showUpdateModal}
        title="approve_task_report_form"
        onHide={handleUpdateCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <ApproveTaskReportForm
            onSubmitButton={handleupdateButtonSubmit}
            ApproveRequestData={ApproveRequestData}
          />
        }
      />
    </div>
  );
};
export default TaskApproveRequests;
